import React, { useState } from 'react';
import { Star } from 'lucide-react';
import clsx from 'clsx';

interface StarRatingProps {
  value: number;
  onChange?: (value: number) => void;
  readonly?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-5 w-5 md:h-4 md:w-4',
  md: 'h-8 w-8 md:h-6 md:w-6',
  lg: 'h-10 w-10 md:h-8 md:w-8',
};

const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  readonly = false,
  size = 'md',
  className,
}) => {
  const [hoverValue, setHoverValue] = useState(0);

  const displayValue = hoverValue || value;

  return (
    <div className={clsx('inline-flex gap-1', className)}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => onChange?.(star)}
          onMouseEnter={() => !readonly && setHoverValue(star)}
          onMouseLeave={() => !readonly && setHoverValue(0)}
          className={clsx(
            'transition-colors duration-150 p-1',
            readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110',
          )}
        >
          <Star
            className={clsx(
              sizeClasses[size],
              star <= displayValue
                ? 'fill-white text-fg-primary'
                : 'fill-transparent text-zinc-700',
            )}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
